import { render } from "./SearchFullResults.vue?vue&type=template&id=acd18e3a&scoped=true"
import script from "./SearchFullResults.vue?vue&type=script&lang=js"
export * from "./SearchFullResults.vue?vue&type=script&lang=js"

import "./SearchFullResults.vue?vue&type=style&index=0&id=acd18e3a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd18e3a"]])

export default __exports__